import styled from 'styled-components'

export const ImageContainer = styled.div`
    position: relative;
    width: 100%;
    height: 48rem;
    overflow: hidden;

    @media (max-width: 768px) {
        height: 28rem;
    }

    @media (max-width: 480px) {
        height: 20rem;
    }
`

export const Image = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
    display: block;
`

export const ImageOverlay = styled.div`
    position: absolute;
    display: flex;
    top: 66.67%;
    left: 0;
    width: 40rem;
    height: 10rem;
    background-color: rgba(226, 232, 240, 0.9);
    padding: 2rem;
    box-sizing: border-box;
    align-items: center;

    @media (max-width: 768px) {
        top: 60%;
        width: 100%;
        height: 8rem;
        padding: 1rem 1.5rem;
    }

    @media (max-width: 480px) {
        top: 55%;
        height: 6rem;
        padding: 0.5rem 1rem;
    }
`

export const Title = styled.p<{ fontSize: number }>`
    font-size: ${(props) => props.fontSize}px;
    font-family: 'Poppins', sans-serif;
    font-weight: 500;
    margin: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    @media (max-width: 768px) {
        font-size: ${(props) => Math.min(props.fontSize, 28)}px;
    }

    @media (max-width: 480px) {
        font-size: ${(props) => Math.min(props.fontSize, 20)}px;
    }
`
